// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { GenericComponent } from '../components/atoms/GenericComponent';
var Factory = /** @class */ (function () {
    function Factory() {
        this.components = {};
        this.validations = {};
    }
    Factory.prototype.registerValidation = function (validation, identifier) {
        if (!identifier) {
            throw new Error('Invalid validation identifier. A validation identifier is required to register a validation properly.');
        }
        if (this.validations[identifier]) {
            throw new Error('Invalid validation identifier. This validation idetifier is already registered. Try something else.');
        }
        this.validations[identifier] = validation;
    };
    Factory.prototype.registerComponent = function (Component, identifier) {
        var name = identifier || Component.displayName;
        if (!name) {
            throw new Error('Invalid component name. Only components that have "displayName" or are registered with "identifier" can be registered.');
        }
        if (this.components[name]) {
            throw new Error('Invalid component identifier. This component identifier is already registered. Try something else.');
        }
        this.components[name] = Component;
    };
    Factory.prototype.getComponent = function (identifier) {
        return this.components[identifier] || GenericComponent;
    };
    Factory.prototype.getValidation = function (identifier) {
        return this.validations[identifier];
    };
    return Factory;
}());
export var FactoryInstance = new Factory();
export * from './Factory.types';
Object.freeze(FactoryInstance);
